import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import { getActionsConfig } from './actions'
import { Config } from './config'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * @deprecated Use the canonical `ds.table.ec.Plugin` instead.
 */
export class Plugin<
  TTypeParams extends ec.models.TypeParams.Constraint,
> extends ec.plugins.Plugin<
  TTypeParams,
  typeof Plugin.id,
  State,
  Selectors<TTypeParams>,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static readonly id = ec.plugins.Plugin.Id.Custom.create('DsTableOld')
  public readonly config: Config<TTypeParams>

  constructor({ collection, config }: Plugin.constructor.Params<TTypeParams>) {
    const finalConfig = Config.from(config, collection)
    super({
      actions: getActionsConfig(collection),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
    this.config = finalConfig

    this.feature.registerEffects(effects.changePage(this))
  }
}
export namespace Plugin {
  export namespace constructor {
    export type Params<TTypeParams extends ec.models.TypeParams> = Pick<
      Plugin<TTypeParams>,
      'collection'
    > & {
      config?: Config.Options<TTypeParams>
    }
  }
}
